export function index(){
    const fv = document.getElementById('fv');
    const video = document.getElementById('video');
    fv.classList.add('active');
    video.play();
}